import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'dashboardAdmin', en);
i18next.addResourceBundle('jp', 'dashboardAdmin', jp);

const DashboardAdminPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/dashboard/admin',
			component: React.lazy(() => import('./DashboardAdmin'))
		}
	]
};

export default DashboardAdminPageConfig;
